import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        d="M13.253437,7.99868345 L14.2147732,7.99868345 C14.2147741,4.54763269 11.4323964,1.75 8.00015783,1.75 C5.7638154,1.75 3.80336469,2.93771338 2.70870465,4.72001243 L2.70870453,2.64251906 L1.75,2.64251906 L1.75,5.74893761 C1.74999993,6.02507998 1.97385756,6.24893761 2.24999993,6.24893761 C2.24999996,6.24893761 2.24999998,6.24893761 2.25,6.24893754 L5.33675885,6.24893713 L5.33675885,6.24893713 L5.33675885,5.28497791 L3.49045432,5.28497815 C4.40906155,3.74210536 6.08691859,2.71133503 8.00015783,2.7113356 C10.8965168,2.7113364 13.253438,5.07360196 13.253437,7.99868345 Z M2.74687386,7.998631 C2.74687305,10.9237127 5.1037941,13.286026 8.0001545,13.286027 C9.91339242,13.286027 11.591249,12.2552587 12.5098562,10.7123852 L10.6632414,10.7123852 L10.6632414,9.74842548 L13.75,9.74842548 C14.0261424,9.74842548 14.25,9.97228311 14.25,10.2484255 L14.25,13.3548441 L14.25,13.3548441 L13.291296,13.3548441 L13.291296,11.2778559 C12.1965759,13.0598733 10.2362852,14.2473631 8.00015402,14.2473631 C4.56791544,14.2473631 1.78553631,11.449683 1.78553822,7.998631 L2.74687386,7.998631 Z"
        fillOpacity=".4"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}

const RefreshIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default RefreshIcon
